import { useMemo } from "react";

import { FabricDesign } from "src/gen/schema/models/fabric_design";
import { getServerGroupByNodeId } from "src/utils/fabricDesign";

/**
 * Custom hook to get the active GPUs bitmap for a node from the fabric design.
 *
 * @param fabricDesign - The fabric design containing server group information
 * @param nodeId - The ID of the node to get active GPUs for
 * @returns The active GPUs bitmap (0 if not found)
 */
export const useActiveGpus = (
  fabricDesign?: FabricDesign,
  nodeId?: string
): number => {
  return useMemo(() => {
    if (!fabricDesign || !nodeId) return 0;
    const serverGroup = getServerGroupByNodeId(fabricDesign, nodeId);
    return serverGroup?.activeGpus ?? 0;
  }, [fabricDesign, nodeId]);
};
